<div class="prod-details-grid-main-wrapper">
  <div class="prod-details-grid-wrapper">
    <div class="prod-grid-details">
      <ng-container *ngIf="isPlpPopupEnabled; else defaultClickableArea">
        <a
          tabindex="0"
          [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
          (click)="gtmProductClick(product, position)"
        >
          <div class="image-grid-header"></div>
          <div class="image-grid-wrapper">
            <div>
              <cx-media
                class="cx-product-image"
                [container]="getImageRendition(product?.firstVariantImage)"
                format="string"
                [alt]="product?.baseProductName"
                [class.is-missing-fish]="businessType === 'fish'"
                removeImageTitleAttr
              ></cx-media>
            </div>
          </div>
          <div class="details-grid-wrapper">
            <div class="sku">
              <span>{{ product?.baseProduct }}</span>

              <span class="in-stock" *ngIf="product?.inStockFlag === true">
                {{ 'product.inStock' | cxTranslate }}
              </span>

              <ng-container *ngIf="product?.inStockFlag === false && product?.stockStatusDisplay; else noStock">
                <span class="in-stock" *ngIf="product?.stockStatusDisplay === 'inStock'">
                  {{ 'product.inStock' | cxTranslate }}
                </span>
                <span class="no-stock" *ngIf="product?.stockStatusDisplay === 'outOfStock'">
                  {{ 'product.noStock' | cxTranslate }}
                </span>
                <span class="discontinued" *ngIf="product?.stockStatusDisplay === 'discontinued'">
                  {{ 'product.discontinued' | cxTranslate }}
                </span>
              </ng-container>

              <ng-template #noStock>
                <span class="no-stock" *ngIf="product?.inStockFlag === false">
                  {{ 'product.noStock' | cxTranslate }}
                </span>
              </ng-template>
            </div>
          </div>
          <app-tooltip-text
            class="prod-name increased-lines"
            [tooltipContent]="product?.baseProductName"
            [content]="product?.baseProductName"
            placement="bottom"
          >
          </app-tooltip-text>
          <div class="color-variant">
            <ng-container *ngIf="product?.hasVariants && !isPlpPopupEnabled">
              <div
                class="available-multivariant"
                *ngIf="!product?.firstVariantColor && !hasProdColor(product?.baseProduct)"
              >
                {{ 'product.noColorVariants' | cxTranslate }}
              </div>
            </ng-container>
            <cx-media
              class="cx-product-image"
              *ngIf="product?.firstVariantColor"
              [container]="getColorImageRendition(product?.firstVariantColor, product?.baseProduct)"
              [class.is-missing-fish]="businessType === 'fish'"
              removeImageTitleAttr
            ></cx-media>
            <ng-container *ngFor="let image of product?.variantOptions | slice : 0 : 4">
              <ng-container *ngFor="let img of image?.variantOptionQualifiers">
                <ng-container *ngIf="img?.qualifier === 'color' && product?.firstVariantColor?.url !== img?.image?.url">
                  <cx-media
                    class="cx-product-image"
                    [container]="getColorImageRendition(img?.value, product?.baseProduct)"
                    [class.is-missing-fish]="businessType === 'fish'"
                    removeImageTitleAttr
                  ></cx-media>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </a>
        <div class="color-variant-divider"></div>
        <div class="prod-prices">
          <app-promotional-text
            *ngIf="product?.potentialPromotions && !showSrp; else showDealerPricePromo"
            class="d-sm-none d-md-block d-lg-block mt-auto"
            [product]="product"
            [promotionLocation]="'PLP'"
          ></app-promotional-text>
          <ng-template #showDealerPricePromo>
            <app-promotional-text
              *ngIf="dealerPrices && !showSrp"
              class="d-sm-none d-md-block d-lg-block mt-auto"
              [dealerPriceData]="dealerPriceData(product?.code)"
              [promotionLocation]="'PLP'"
            ></app-promotional-text>
          </ng-template>
          <div class="srp-base-wrapper" [class.ofBy-present]="product?.replacementOf && product?.replacedBy">
            <div class="srp-wrapper">
              <div class="label">
                <span>{{ 'product.productList.srp' | cxTranslate }}</span>
              </div>
              <div class="value" *ngIf="product?.variantOptions && product?.srpPrice?.formattedValue; else srp">
                <span class="text-nowrap"
                  >{{ 'product.productList.from' | cxTranslate }} {{ product?.srpPrice?.formattedValue
                  }}<span *ngIf="product?.srpPrice?.formattedValue && showGstInclusive$ | async" class="gst-label">{{
                    'gst.inclusive' | cxTranslate
                  }}</span></span
                >
              </div>
              <ng-template #srp>
                <div class="value">
                  <span class="text-nowrap"
                    >{{ product?.srpPrice?.formattedValue
                    }}<span *ngIf="product?.srpPrice?.formattedValue && showGstInclusive$ | async" class="gst-label">{{
                      'gst.inclusive' | cxTranslate
                    }}</span></span
                  >
                </div>
              </ng-template>
            </div>
            <div class="base-wrapper" *ngIf="!showSrp && !basepriceHidden">
              <div class="label">
                <span>{{ 'product.productList.basePrice' | cxTranslate }}</span>
              </div>
              <div class="value" *ngIf="product?.variantOptions && product?.basePrice?.formattedValue; else baseprice">
                <span class="text-nowrap"
                  >{{ 'product.productList.from' | cxTranslate }} {{ product?.basePrice?.formattedValue
                  }}<span *ngIf="dealerPrice(product?.code) && showGstExclusive$ | async" class="gst-label">{{
                    'gst.exclusive' | cxTranslate
                  }}</span></span
                >
              </div>
              <ng-template #baseprice>
                <div class="value">
                  <span class="text-nowrap"
                    >{{ product?.basePrice?.formattedValue
                    }}<span *ngIf="dealerPrice(product?.code) && showGstExclusive$ | async" class="gst-label">{{
                      'gst.exclusive' | cxTranslate
                    }}</span></span
                  >
                </div>
              </ng-template>
            </div>
            <div class="dealer-wrapper" *ngIf="!showSrp">
              <div class="label">
                <span>{{ 'product.productList.dealerPrice' | cxTranslate }}</span>
              </div>
              <div
                class="value"
                [class.erpPromo]="
                  dealerPriceData(product?.code)?.promotionMessage &&
                  dealerPriceData(product?.code)?.promotionMessage !== ''
                "
                *ngIf="product?.variantOptions && dealerPrice(product?.code); else dealerprice"
              >
                <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(product?.code); else dealerPriceReady">
                  <div class="spinner-shimano plp-grid" *ngIf="this.hasDealerPriceSubs">
                    <div></div>
                  </div>
                  <div class="no-dealer-price no-dealer-price-pgi" *ngIf="!this.hasDealerPriceSubs"></div>
                </div>
                <ng-template #dealerPriceReady>
                  <span class="text-nowrap"
                    >{{ 'product.productList.from' | cxTranslate }} {{ dealerPrice(product?.code)
                    }}<span *ngIf="dealerPrice(product?.code) && showGstExclusive$ | async" class="gst-label">{{
                      'gst.exclusive' | cxTranslate
                    }}</span></span
                  >
                  <app-erp-promotional-text
                    *ngIf="dealerPrices && !showSrp"
                    class="d-sm-none d-xl-block mt-auto"
                    [dealerPriceData]="dealerPriceData(product?.code)"
                  ></app-erp-promotional-text>
                </ng-template>
              </div>
              <ng-template #dealerprice>
                <div
                  class="value"
                  [class.erpPromo]="
                    dealerPriceData(product?.code)?.promotionMessage &&
                    dealerPriceData(product?.code)?.promotionMessage !== ''
                  "
                >
                  <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(product?.code); else dealerPriceReady">
                    <div class="spinner-shimano plp-grid" *ngIf="this.hasDealerPriceSubs">
                      <div></div>
                    </div>
                    <div class="no-dealer-price no-dealer-price-pgi" *ngIf="!this.hasDealerPriceSubs"></div>
                  </div>
                  <ng-template #dealerPriceReady>
                    <span class="text-nowrap"
                      >{{ dealerPrice(product?.code)
                      }}<span *ngIf="dealerPrice(product?.code) && showGstExclusive$ | async" class="gst-label">{{
                        'gst.exclusive' | cxTranslate
                      }}</span></span
                    >
                    <app-erp-promotional-text
                      *ngIf="dealerPrices && !showSrp"
                      class="d-sm-none d-xl-block mt-auto"
                      [dealerPriceData]="dealerPriceData(product?.code)"
                    ></app-erp-promotional-text>
                  </ng-template>
                </div>
              </ng-template>
            </div>
            <div class="replacement-Of-By-wrapper" *ngIf="product?.replacementOf || product?.replacedBy">
              <div
                class="replacement-of"
                [ngClass]="isPlpPopupEnabled ? 'has-border-box' : ''"
                *ngIf="product?.replacementOf"
              >
                <div class="label">{{ 'product.productList.replacementOf' | cxTranslate }}</div>
                <div class="value">
                  <a
                    tabindex="0"
                    class="pdp-link"
                    [routerLink]="{ cxRoute: 'product', params: product.replacementOf } | cxUrl"
                    (click)="replacement($event)"
                  >
                    <app-tooltip-text
                      class="prod-name-grid-list"
                      [tooltipContent]="product?.replacementOf?.name"
                      [content]="product?.replacementOf?.name"
                      placement="bottom"
                    >
                    </app-tooltip-text>
                  </a>
                </div>
              </div>
              <div
                class="replaced-by"
                [ngClass]="isPlpPopupEnabled ? 'has-border-box' : ''"
                *ngIf="product?.replacedBy"
              >
                <div class="label">{{ 'product.productList.replacedBy' | cxTranslate }}</div>
                <div class="value">
                  <a
                    tabindex="0"
                    class="pdp-link"
                    [routerLink]="{ cxRoute: 'product', params: product.replacedBy } | cxUrl"
                    (click)="replacement($event)"
                  >
                    <app-tooltip-text
                      class="prod-name-grid-list"
                      [tooltipContent]="product?.replacedBy?.name"
                      [content]="product?.replacedBy?.name"
                      placement="bottom"
                    >
                    </app-tooltip-text>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-template #defaultClickableArea>
        <a
          tabindex="0"
          [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
          (click)="gtmProductClick(product, position)"
        >
          <div class="image-grid-header"></div>
          <div class="image-grid-wrapper">
            <div>
              <cx-media
                class="cx-product-image"
                [container]="getImageRendition(product?.firstVariantImage)"
                format="string"
                [alt]="product?.baseProductName"
                [class.is-missing-fish]="businessType === 'fish'"
                removeImageTitleAttr
              ></cx-media>
            </div>
          </div>
          <div class="details-grid-wrapper">
            <div class="sku">
              <span>{{ product?.baseProduct }}</span>

              <span class="in-stock" *ngIf="product?.inStockFlag === true">
                {{ 'product.inStock' | cxTranslate }}
              </span>

              <ng-container *ngIf="product?.inStockFlag === false && product?.stockStatusDisplay; else noStock">
                <span class="in-stock" *ngIf="product?.stockStatusDisplay === 'inStock'">
                  {{ 'product.inStock' | cxTranslate }}
                </span>
                <span class="no-stock" *ngIf="product?.stockStatusDisplay === 'outOfStock'">
                  {{ 'product.noStock' | cxTranslate }}
                </span>
                <span class="discontinued" *ngIf="product?.stockStatusDisplay === 'discontinued'">
                  {{ 'product.discontinued' | cxTranslate }}
                </span>
              </ng-container>

              <ng-template #noStock>
                <span class="no-stock" *ngIf="product?.inStockFlag === false">
                  {{ 'product.noStock' | cxTranslate }}
                </span>
              </ng-template>
            </div>
          </div>
          <app-tooltip-text
            class="prod-name"
            [tooltipContent]="product?.baseProductName"
            [content]="product?.baseProductName"
            placement="bottom"
          >
          </app-tooltip-text>
          <div class="color-variant">
            <ng-container *ngIf="product?.hasVariants">
              <div
                class="available-multivariant"
                *ngIf="!product?.firstVariantColor && !hasProdColor(product?.baseProduct)"
              >
                {{ 'product.noColorVariants' | cxTranslate }}
              </div>
            </ng-container>
            <cx-media
              class="cx-product-image"
              *ngIf="product?.firstVariantColor"
              [container]="getColorImageRendition(product?.firstVariantColor, product?.baseProduct)"
              [class.is-missing-fish]="businessType === 'fish'"
              removeImageTitleAttr
            ></cx-media>
            <ng-container *ngFor="let image of product?.variantOptions | slice : 0 : 4">
              <ng-container *ngFor="let img of image?.variantOptionQualifiers">
                <ng-container *ngIf="img?.qualifier === 'color' && product?.firstVariantColor?.url !== img?.image?.url">
                  <cx-media
                    class="cx-product-image"
                    [container]="getColorImageRendition(img?.value, product?.baseProduct)"
                    [class.is-missing-fish]="businessType === 'fish'"
                    removeImageTitleAttr
                  ></cx-media>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
          <div class="color-variant-divider"></div>
          <div class="prod-prices">
            <app-promotional-text
              *ngIf="product?.potentialPromotions && !showSrp; else showDealerPricePromo"
              class="d-sm-none d-md-block d-lg-block mt-auto"
              [product]="product"
              [promotionLocation]="'PLP'"
            ></app-promotional-text>
            <ng-template #showDealerPricePromo>
              <app-promotional-text
                *ngIf="dealerPrices && !showSrp"
                class="d-sm-none d-md-block d-lg-block mt-auto"
                [dealerPriceData]="dealerPriceData(product?.code)"
                [promotionLocation]="'PLP'"
              ></app-promotional-text>
            </ng-template>
            <div class="srp-base-wrapper" [class.ofBy-present]="product?.replacementOf && product?.replacedBy">
              <div class="srp-wrapper">
                <div class="label">
                  <span>{{ 'product.productList.srp' | cxTranslate }}</span>
                </div>
                <div class="value" *ngIf="product?.variantOptions && product?.srpPrice?.formattedValue; else srp">
                  <span class="text-nowrap"
                    >{{ 'product.productList.from' | cxTranslate }} {{ product?.srpPrice?.formattedValue
                    }}<span *ngIf="product?.srpPrice?.formattedValue && showGstInclusive$ | async" class="gst-label">{{
                      'gst.inclusive' | cxTranslate
                    }}</span></span
                  >
                </div>
                <ng-template #srp>
                  <div class="value">
                    <span class="text-nowrap"
                      >{{ product?.srpPrice?.formattedValue
                      }}<span
                        *ngIf="product?.srpPrice?.formattedValue && showGstInclusive$ | async"
                        class="gst-label"
                        >{{ 'gst.inclusive' | cxTranslate }}</span
                      ></span
                    >
                  </div>
                </ng-template>
              </div>
              <div class="base-wrapper" *ngIf="!showSrp && !basepriceHidden">
                <div class="label">
                  <span>{{ 'product.productList.basePrice' | cxTranslate }}</span>
                </div>
                <div
                  class="value"
                  *ngIf="product?.variantOptions && product?.basePrice?.formattedValue; else baseprice"
                >
                  <span class="text-nowrap"
                    >{{ 'product.productList.from' | cxTranslate }} {{ product?.basePrice?.formattedValue
                    }}<span *ngIf="dealerPrice(product?.code) && showGstExclusive$ | async" class="gst-label">{{
                      'gst.exclusive' | cxTranslate
                    }}</span></span
                  >
                </div>
                <ng-template #baseprice>
                  <div class="value">
                    <span class="text-nowrap"
                      >{{ product?.basePrice?.formattedValue
                      }}<span *ngIf="dealerPrice(product?.code) && showGstExclusive$ | async" class="gst-label">{{
                        'gst.exclusive' | cxTranslate
                      }}</span></span
                    >
                  </div>
                </ng-template>
              </div>
              <div class="dealer-wrapper" *ngIf="!showSrp">
                <div class="label">
                  <span>{{ 'product.productList.dealerPrice' | cxTranslate }}</span>
                </div>
                <div
                  class="value"
                  [class.erpPromo]="
                    dealerPriceData(product?.code)?.promotionMessage &&
                    dealerPriceData(product?.code)?.promotionMessage !== ''
                  "
                  *ngIf="product?.variantOptions && dealerPrice(product?.code); else dealerprice"
                >
                  <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(product?.code); else dealerPriceReady">
                    <div class="spinner-shimano plp-grid" *ngIf="this.hasDealerPriceSubs">
                      <div></div>
                    </div>
                    <div class="no-dealer-price no-dealer-price-pgi" *ngIf="!this.hasDealerPriceSubs"></div>
                  </div>
                  <ng-template #dealerPriceReady>
                    <span class="text-nowrap"
                      >{{ 'product.productList.from' | cxTranslate }} {{ dealerPrice(product?.code)
                      }}<span *ngIf="dealerPrice(product?.code) && showGstExclusive$ | async" class="gst-label">{{
                        'gst.exclusive' | cxTranslate
                      }}</span></span
                    >
                    <app-erp-promotional-text
                      *ngIf="dealerPrices && !showSrp"
                      class="d-sm-none d-xl-block mt-auto"
                      [dealerPriceData]="dealerPriceData(product?.code)"
                    ></app-erp-promotional-text>
                  </ng-template>
                </div>
                <ng-template #dealerprice>
                  <div
                    class="value"
                    [class.erpPromo]="
                      dealerPriceData(product?.code)?.promotionMessage &&
                      dealerPriceData(product?.code)?.promotionMessage !== ''
                    "
                  >
                    <div class="spinner-shimano-wrapper-dp" *ngIf="!dealerPrice(product?.code); else dealerPriceReady">
                      <div class="spinner-shimano plp-grid" *ngIf="this.hasDealerPriceSubs">
                        <div></div>
                      </div>
                      <div class="no-dealer-price no-dealer-price-pgi" *ngIf="!this.hasDealerPriceSubs"></div>
                    </div>
                    <ng-template #dealerPriceReady>
                      <span class="text-nowrap"
                        >{{ dealerPrice(product?.code)
                        }}<span *ngIf="dealerPrice(product?.code) && showGstExclusive$ | async" class="gst-label">{{
                          'gst.exclusive' | cxTranslate
                        }}</span></span
                      >
                      <app-erp-promotional-text
                        *ngIf="dealerPrices && !showSrp"
                        class="d-sm-none d-xl-block mt-auto"
                        [dealerPriceData]="dealerPriceData(product?.code)"
                      ></app-erp-promotional-text>
                    </ng-template>
                  </div>
                </ng-template>
              </div>
              <div class="replacement-of" *ngIf="product?.replacementOf">
                <div class="label">{{ 'product.productList.replacementOf' | cxTranslate }}</div>
                <div class="value">
                  <a
                    tabindex="0"
                    class="pdp-link"
                    [routerLink]="{ cxRoute: 'product', params: product.replacementOf } | cxUrl"
                    (click)="replacement($event)"
                  >
                    {{ product?.replacementOf?.name }}
                  </a>
                </div>
              </div>
              <div class="replaced-by" *ngIf="product?.replacedBy">
                <div class="label">{{ 'product.productList.replacedBy' | cxTranslate }}</div>
                <div class="value">
                  <a
                    tabindex="0"
                    class="pdp-link"
                    [routerLink]="{ cxRoute: 'product', params: product.replacedBy } | cxUrl"
                    (click)="replacement($event)"
                  >
                    {{ product?.replacedBy?.name }}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </a>
      </ng-template>
    </div>
    <div class="cta-wrapper" [ngClass]="isPlpPopupEnabled ? 'border-top-remove' : ''">
      <ng-container *ngIf="!isPlpPopupEnabled">
        <div>
          <a
            tabindex="0"
            [routerLink]="{ cxRoute: 'product', params: product } | cxUrl"
            (click)="gtmProductClick(product, position)"
          >
            <mat-icon
              matTooltip="{{ 'buttonTooltip.plp.pdpButton' | cxTranslate }}"
              [matTooltipPosition]="'below'"
              matTooltipClass="icon-tooltip"
              aria-label="displays a tooltip in bottom"
              class="material-icons-sharp light"
              >assignment</mat-icon
            >
          </a>
        </div>
      </ng-container>

      <div
        *ngIf="isPlpPopupEnabled"
        class="button-wrapper"
        [ngClass]="!product?.showOrderFormButton ? 'reduce-size-button' : ''"
        matTooltip="{{ 'buttonTooltip.addToCart.title' | cxTranslate }}"
        [matTooltipPosition]="'below'"
        [matTooltipClass]="'button-tooltip'"
        aria-label="displays a tooltip in bottom"
      >
        <button
          #triggerButton
          [disabled]="!dealerPrice(product?.code)"
          class="btn btn-primary"
          type="button"
          (click)="plpGridModalScroll(product)"
        >
          <mat-icon svgIcon="add-to-cart"></mat-icon>
        </button>
      </div>

      <div class="order-form" *ngIf="product?.showOrderFormButton && !isPlpPopupEnabled">
        <a
          tabindex="0"
          type="button"
          [routerLink]="
            { cxRoute: 'orderForm', params: { code: product?.baseProduct, name: product?.baseProductName } } | cxUrl
          "
        >
          <mat-icon
            matTooltip="{{ 'buttonTooltip.plp.orderFormButton' | cxTranslate }}"
            [matTooltipPosition]="'below'"
            matTooltipClass="icon-tooltip"
            aria-label="displays a tooltip in bottom"
            class="material-icons-sharp light"
            >note_add</mat-icon
          >
        </a>
      </div>
      <div
        matTooltip="{{ 'buttonTooltip.plp.orderFormButton' | cxTranslate }}"
        [matTooltipPosition]="'below'"
        matTooltipClass="icon-tooltip"
        aria-label="displays a tooltip in bottom"
        class="order-form-link-button"
        *ngIf="product?.showOrderFormButton && isPlpPopupEnabled"
      >
        <a
          tabindex="0"
          [routerLink]="
            { cxRoute: 'orderForm', params: { code: product?.baseProduct, name: product?.baseProductName } } | cxUrl
          "
        >
          <mat-icon svgIcon="order-form-plp"></mat-icon>
        </a>
      </div>
    </div>
  </div>
</div>
